/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface ParamsProps {
  idLead: string | undefined;
  codigoTemperatura: 1 | 2 | 3;
}

interface Params {
  idLeadCorretor: string | undefined;
  body: ParamsProps;
}

export function useAlterarTemperatura(props: Params) {
  const registerData = async () => {
    const ALTERAR_TEMPERATURA = `${leadsWebEnviroment}/commom/leads/alterar-temperatura-lead/v1/${props.idLeadCorretor}`;
    return await instance.put(ALTERAR_TEMPERATURA, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["alterar_temperatura"],
    onSuccess: () => {
      toast.success("Temperatura alterada com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      console.log(error?.response);
      if (error?.response?.status >= 500) {
        toast.error(`Houve um erro: Status: ${error?.response?.status}`, {
          autoClose: 10000,
        });
      } else {
        const errorMessages = error.response.data.notifications.map(
          (item: any) => `\n${item?.message}\n`
        );

        toast.error(errorMessages.join(""), { autoClose: 10000 });
      }
    },
  });
  return query;
}
